"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Rating = _interopRequireDefault(require("../../rating/Rating"));
var _productCardRatingModule = _interopRequireDefault(require("./product-card-rating.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ProductCardRating = function ProductCardRating(_ref) {
  var _ref$rating = _ref.rating,
    rating = _ref$rating === void 0 ? {} : _ref$rating,
    isListViewOn = _ref.isListViewOn,
    className = _ref.className;
  var reviews = rating.reviews;
  if (!Object.keys(rating).length || !reviews) {
    return '';
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames2["default"])(_productCardRatingModule["default"].rating, className, _defineProperty({}, _productCardRatingModule["default"]['list-view'], isListViewOn)),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Rating["default"], {
      rating: rating
    })
  });
};
ProductCardRating.defaultProps = {
  rating: {},
  isListViewOn: false
};
ProductCardRating.propTypes = {
  rating: _propTypes["default"].shape({
    averageRating: _propTypes["default"].number,
    reviews: _propTypes["default"].number,
    isListViewOn: _propTypes["default"].bool
  })
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(ProductCardRating);